module.exports = __webpack_public_path__ + "img/Декларация_о_соответствии_Щебень_5-20,20-40,40-70_pages-to-jpg-0001.d19d13aa.jpg";